/**
 * Vocabulário do domínio.
 *
 * Cada valor aqui foi extraído do protótipo navegável
 * (Arena_frontend/Docs/arena-alpha-prototipo.html). Quando um termo
 * aparece em mais de uma tela, ele vive neste arquivo — backend e
 * frontend falam a mesma língua e o banco usa os mesmos rótulos.
 *
 * Padrão: união de literais + objeto congelado com os valores, para
 * poder iterar. Enums do TypeScript ficam de fora de propósito — eles
 * não são serializáveis nem comparáveis com o que vem do banco.
 */
// ---------------------------------------------------------------------
// Alunos · filtros de #v-alunos
// ---------------------------------------------------------------------
export const STATUS_ALUNO = ['Experimental', 'Ativo', 'Inativo', 'Cancelado'];
/** "Como conheceu a arena" · #m-aluno e o relatório de origem em #v-site */
export const ORIGEM_ALUNO = [
    'Indicacao',
    'Instagram',
    'Site',
    'PassouEmFrente',
    'Importacao',
];
// ---------------------------------------------------------------------
// Agenda · os cinco tipos de marcação de #m-reserva
// ---------------------------------------------------------------------
export const TIPO_MARCACAO = [
    'TurmaFixa',
    'LocacaoAvulsa',
    'Experimental',
    'Evento',
    'Bloqueio',
];
export const SITUACAO_PAGAMENTO_MARCACAO = [
    'Pago',
    'Sinal',
    'APagar',
    'Isento',
    'NaMensalidade',
];
// ---------------------------------------------------------------------
// Turmas · #m-turma e #m-chamada
// ---------------------------------------------------------------------
/**
 * As modalidades da arena.
 *
 * `Futvolei` é o token gravado desde a primeira migration — o rótulo que
 * a tela mostra é "Futevôlei" (`ROTULO_MODALIDADE`, em
 * `schemas/modalidades.ts`). O token fica como está de propósito:
 * renová-lo exigiria reescrever linha gravada, e valor de vocabulário
 * trocado no banco é a migration que não volta atrás.
 *
 * `Outra` é a modalidade PERSONALIZADA: ela exige um nome junto, no campo
 * `modalidade_outra` de quem a declara. É o que permite cadastrar
 * "ritmos" ou "treino de saque" sem deploy — ver `conferirModalidade`.
 *
 * A ordem é a dos selects: a lista fechada primeiro, a locação livre
 * depois, a personalizada por último.
 */
export const MODALIDADE = [
    'Futvolei',
    'Volei',
    'BeachTennis',
    'Funcional',
    'Livre',
    'Outra',
];
/** O valor que pede o nome livre. Ninguém compara com a string crua. */
export const MODALIDADE_PERSONALIZADA = 'Outra';
export const NIVEL_TURMA = ['Iniciante', 'Intermediario', 'Avancado'];
export const PRESENCA_CHAMADA = ['Presente', 'Falta', 'Reposicao'];
// ---------------------------------------------------------------------
// Dinheiro · #m-pagamento, #m-comanda, #m-lancamento
// ---------------------------------------------------------------------
export const FORMA_PAGAMENTO = ['Pix', 'Dinheiro', 'Cartao', 'Boleto', 'Mensalidade'];
/** Estado derivado: `Vencida` nunca é gravado, é calculado. Ver 12-planos-faturas.md */
export const SITUACAO_FATURA = ['EmAberto', 'Paga', 'Vencida', 'Cancelada'];
export const SITUACAO_LANCAMENTO = ['Previsto', 'Realizado'];
export const TIPO_LANCAMENTO = ['Entrada', 'Saida'];
/** #m-lancamento · o rateio que separa o bar das quadras */
export const CENTRO_DE_CUSTO = ['Geral', 'Quadra1', 'Quadra2', 'Bar'];
export const FREQUENCIA_PLANO = ['UmaVez', 'DuasVezes', 'TresVezes', 'Ilimitado'];
export const FIDELIDADE_PLANO = ['Mensal', 'Trimestral', 'Semestral'];
// ---------------------------------------------------------------------
// Site · #v-site
// ---------------------------------------------------------------------
export const SITUACAO_PEDIDO = ['Pendente', 'Confirmado', 'Recusado'];
/**
 * Por onde o pedido de horário chegou.
 *
 * `Site` é histórico: o formulário público existiu e foi removido, e os
 * pedidos que ele gerou continuam na fila com essa origem — valor de
 * vocabulário não se reescreve porque a porta fechou. `Telefone` é a
 * porta de hoje: a recepção anota o que chegou por ligação, mensagem ou
 * balcão.
 */
export const ORIGEM_PEDIDO = ['Site', 'Telefone'];
// ---------------------------------------------------------------------
// Estoque · #v-estoque
// ---------------------------------------------------------------------
export const TIPO_MOVIMENTO_ESTOQUE = [
    'Entrada',
    'SaidaPorVenda',
    'AjusteInventario',
    'Perda',
];
// ---------------------------------------------------------------------
// Auditoria · #v-acessos. Ver 03-access-tres-dimensoes.md
// ---------------------------------------------------------------------
export const ACAO_AUDITADA = [
    'Leitura',
    'Criacao',
    'Alteracao',
    'Exclusao',
    'Anonimizacao',
    /**
     * Tentativa recusada pelo guard.
     *
     * Não é redundante com o log de erro: o critério de aceite do
     * documento 03 exige que a tentativa negada fique NA TRILHA, junto
     * com os acessos legítimos. Quem investiga um incidente precisa ver
     * as duas coisas na mesma consulta — e é a série de negações que
     * denuncia alguém tateando o que não é dele.
     */
    'Negacao',
];
//# sourceMappingURL=index.js.map